/* eslint-disable */
import {
  ActiveTab,
  Dialog,
  Pagination,
  SingleAction,
  TabActionDialog,
  BulkAction,
  Filters,
  FiltersWithMultipleValues
} from "@saleor/types";
import {
  // WarehouseListUrlDialog,
  WarehouseListUrlFilters,
  WarehouseListUrlSort
} from "@saleor/warehouses/urls";
import { stringify } from "qs";
import urlJoin from "url-join";

export const ProducttagsSection = "/producttags/";
export const ProducttagsListPath = ProducttagsSection;
export const ProducttagsListSection = urlJoin(
  ProducttagsSection,
  "producttags"
);
export const producttagPath = (id: string) => urlJoin(ProducttagsSection, id);

export enum SaleListUrlFiltersEnum {
  type = "type",
  startedFrom = "startedFrom",
  startedTo = "startedTo",
  query = "query"
}
export enum SaleListUrlFiltersWithMultipleValues {
  status = "status"
}
export type ProducttagsListUrlDialog = "remove" | TabActionDialog;
export type ProducttagsListUrlQueryParams = ActiveTab &
  // // shipmentListUrlFilters &
  // // shipmentListUrlSort &
  // // Dialog<shipmentListUrlDialog> &
  // Pagination;
  BulkAction &
  Dialog<ProducttagsListUrlDialog> &
  Pagination &
  WarehouseListUrlFilters &
  WarehouseListUrlSort &
  SingleAction;
export type SaleListUrlFilters = Filters<SaleListUrlFiltersEnum> &
  FiltersWithMultipleValues<SaleListUrlFiltersWithMultipleValues>;
export const ProducttagsAddPath = urlJoin(ProducttagsSection, "add");
export const ProducttagsAddUrl = ProducttagsAddPath;
export type ProductTagsUrlDialog =
  | "assign-category"
  | "assign-collection"
  | "assign-product"
  | "assign-variant"
  | "unassign-category"
  | "unassign-collection"
  | "unassign-product"
  | "unassign-variant"
  | "remove";

export enum ProductTageDetailsPageTab {
  categories = "categories",
  collections = "collections",
  products = "products",
  variants = "variants"
  // saleProducts = "saleProducts"
}
export type productTageQueryParams = Pagination &
  BulkAction &
  Dialog<ProductTagsUrlDialog> &
  ActiveTab<ProductTageDetailsPageTab>;

export const productTageseUrl = (id: string, params?: productTageQueryParams) =>
  producttagPath(encodeURIComponent(id)) + "?" + stringify(params);

export const producttagsListUrl = (params?: ProducttagsListUrlQueryParams) =>
  ProducttagsListPath + "?" + stringify(params);
